import { StyleSheet } from '../../compiler'
import { colors } from '../../constants'

export const CATEGORY_BADGES_WIDTH_PERCENT = '47.31%'

const styles = StyleSheet.create({
  pageContainer: { paddingTop: 64 },
  page: {
    backgroundColor: '#fff'
  },
  header: {
    backgroundColor: '#F5F7FA',
    height: 180,
    width: '100%',
    position: 'relative'
  },
  badgesContainer: {
    backgroundColor: colors.lightPaleGrey,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: colors.lightGrey,
    overflow: 'hidden'
  },
  categoryBadgesContainer: {
    gap: 16,
    flexWrap: 'wrap',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: 16
  }
})

export default styles
